import { createApp, h } from "vue";
import App from "./App.vue";
import http from "./http";
import router from "./router";
import auth from "./plugins/auth.js";
//  import GlobalPlugin from './plugins/GlobalPlugin';

import "./assets/css/global.css";

const app = createApp({
  render: () => h(App)
});

app.use(http);
app.use(router);
app.use(auth);
//  app.use(GlobalPlugin);

app.mount("#app");
